// Owner-framing disclosure for available-soon surfaces (Legal-approved wording).
export const AVAILABLE_SOON_DISCLOSURE =
  '“Available Soon” homes shown are owned by Opendoor and not subject to listing agreements with Opendoor Brokerage, Opendoor Affiliates, or other brokerages.';

/**
 * Consent version recorded with each notify-me opt-in. The key names the copy
 * below; revising the copy means minting a new key, never editing in place,
 * because stored subscriptions reference the key they were collected under.
 */
export const AVAILABLE_SOON_NOTIFY_CONSENT_VERSION = 'available_soon_notify_sms_v1';

/**
 * The disclosure the notify-me card presents. Written as a verbatim literal
 * rather than composed from the carrier boilerplate so it can be read straight
 * against what legal approved; `availableSoon.test.ts` pins the boilerplate
 * suffix so the two can never drift apart unnoticed.
 */
export const AVAILABLE_SOON_NOTIFY_SMS_CONSENT =
  'By providing your phone number, you agree to receive a one-time text message from Opendoor when this home becomes available. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to cancel. Consent is not a condition of purchase.';
